import React from 'react';
import {Table} from 'web-components';

export const getBaseLevelTableHeader = columns => {
	return (
		<Table.Header>
			<Table.HeaderColumn usePadding flex={1} align="left" visible={true} width="MEDIUM">
				<Table.HeaderColumn.Title>{'Project'}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn usePadding align="left" visible={true} width="MEDIUM">
				<Table.HeaderColumn.Title>{'Task'}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="right" usePadding visible={true} width="SMALL">
				<Table.HeaderColumn.Title>{'Reported'}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="left" usePadding visible={columns['timeReg.notes']} width="MEDIUM">
				<Table.HeaderColumn.Title>{'Notes'}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="left" usePadding visible={columns['timeReg.date']} width="SMALL">
				<Table.HeaderColumn.Title>{'Date'}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="left" usePadding visible={true} width="MEDIUM">
				<Table.HeaderColumn.Title>{'Person'}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="left" usePadding visible={columns['timeReg.person.role.name']} width="MEDIUM">
				<Table.HeaderColumn.Title>{'Role'}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="left" usePadding visible={columns['timeReg.client.info']} width="MEDIUM">
				<Table.HeaderColumn.Title>{'Client'}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="left" usePadding visible={columns['timeReg.billable']} width="SMALL">
				<Table.HeaderColumn.Title>{'Billable'}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="right" usePadding visible={columns['timeReg.price']} width="MEDIUM">
				<Table.HeaderColumn.Title>{'Actual Revenue'}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="right" usePadding visible={columns['timeReg.cost']} width="MEDIUM">
				<Table.HeaderColumn.Title>{'Actual Cost'}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="left" usePadding visible={columns['timeReg.invoiced']} width="SMALL">
				<Table.HeaderColumn.Title>{'Invoiced'}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
			<Table.HeaderColumn align="left" usePadding visible={columns['timeReg.approvalStatus']} width="SMALL">
				<Table.HeaderColumn.Title>{'Approved'}</Table.HeaderColumn.Title>
			</Table.HeaderColumn>
		</Table.Header>
	);
};
